/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_something_went_wrong_our_engineers_notified: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Oops, something went wrong... Our engineers have been notified of this issue and will be hard at work getting everything working as soon as possible.`,
    es: `Nuestros ingenieros han sido notificados de este problema y trabajarán para que todo funcione lo antes posible.`,
  };
  return phrases[locale] || phrases.en || `playlist description`;
};
